import { FC } from "react";
import { Handle, Position } from "react-flow-renderer";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { useStore, connect } from "src/store/connect";

interface BackgroundCheckBlockProps {
  data: NodeData;
}

interface Field {
  title: string;
  isVariable: boolean;
  value: string;
}

const BackgroundCheckBlock: FC<BackgroundCheckBlockProps> = ({ data }) => {
  const classes = useStyles();
  const state = useStore();

  const getVariableKey = (id: string | undefined) => {
    if (!id) {
      return "";
    }
    const variable = state.flow.variables?.get(id);
    return variable?.key;
  };

  const getFields = (): Field[] => {
    let fields: Field[] = [];

    if (!data.backgroundCheckInput) {
      return [
        {
          title: "Nombre",
          isVariable: true,
          value: "",
        },
        {
          title: "Apellido",
          isVariable: true,
          value: "",
        },
        {
          title: "ID",
          isVariable: true,
          value: "",
        },
        {
          title: "País",
          isVariable: true,
          value: "",
        },
      ];
    }

    fields.push({
      title: "Nombre",
      isVariable: data.backgroundCheckInput.firstName.default !== "",
      value:
        (data.backgroundCheckInput.firstName.default as string) ||
        getVariableKey(data.backgroundCheckInput.firstName.variableID) ||
        "",
    });

    fields.push({
      title: "Apellido",
      isVariable: data.backgroundCheckInput.lastName.default !== "",
      value:
        (data.backgroundCheckInput.lastName.default as string) ||
        getVariableKey(data.backgroundCheckInput.lastName.variableID) ||
        "",
    });

    fields.push({
      title: "ID",
      isVariable: data.backgroundCheckInput.nationalId.default !== "",
      value:
        (data.backgroundCheckInput.nationalId.default as string) ||
        getVariableKey(data.backgroundCheckInput.nationalId.variableID) ||
        "",
    });

    fields.push({
      title: "País",
      isVariable: data.backgroundCheckInput.country.default !== "",
      value:
        (data.backgroundCheckInput.country.default as string) ||
        getVariableKey(data.backgroundCheckInput.country.variableID) ||
        "",
    });

    return fields;
  };

  return (
    <div className={classes.root}>
      <Handle
        type="target"
        position={Position.Left}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={data.connectable}
      />
      <div
        className={`${
          !data.highlighted && state.simulationRunning ? classes.opacity : ""
        }`}
      >
        <Typography className={classes.title}>
          Validación de Antecedentes
        </Typography>
        <Typography className={classes.subtitle}>
          Información a consultar
        </Typography>
        {getFields().map((field) => {
          return (
            <div className={classes.fieldContainer}>
              <span className={classes.fieldSeparator} />
              <Typography className={classes.labelVariable}>
                {field.title}:
                {field.isVariable ? (
                  <span>{` ${field.value}`}</span>
                ) : (
                  <span className={classes.variable}>
                    {` {{ ${field.value} }}`}
                  </span>
                )}
              </Typography>
            </div>
          );
        })}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        isConnectable={false}
      />
    </div>
  );
};

export default connect(BackgroundCheckBlock);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "259px",
    padding: "22px 10px 35px 26px",
    borderRadius: "8px",
    boxShadow: "0 2px 24px 0 rgba(0, 0, 0, 0.08)",
    border: "solid 1px #5E52F9",
    borderTopWidth: "12px",
    backgroundColor: "#fff",
    color: "#1D262C",
  },
  title: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "21px",
  },
  subtitle: {
    margin: "8px 0 28px 0",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "21px",
    opacity: "0.57",
  },
  opacity: {
    opacity: 0.36,
  },
  label: {
    fontSize: "14px",
    fontWeight: 500,
    overflowWrap: "break-word",
  },
  labelVariable: {
    fontSize: "14px",
    fontWeight: 500,
    overflowWrap: "break-word",
    marginTop: "10px",
  },
  variable: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0091ff",
    overflowWrap: "break-word",
  },
  fieldContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 10fr",
    margin: "0 0 10px 0",
  },
  fieldSeparator: {
    width: "8px",
    height: "38px",
    borderRadius: "2.5px",
    backgroundColor: "#64DFEE",
  },
}));
